import React, { useEffect } from 'react';
import { Controller } from 'react-hook-form';


import { Stack } from 'ui/stack';

import Input from 'components/partials/input/input';
import { TextArea } from 'ui/text-area';

import { useGoalForm } from 'containers/admin/clients/client/tabs-components/goals-tab/goals-manager/goal/context/context';

interface OtherGoalFormProps {
  isDisabled: boolean;
}

const OtherGoalForm = ({
  isDisabled,
}: OtherGoalFormProps): React.JSX.Element => {
  const { control, setFocus } = useGoalForm();

  useEffect(() => {
    setFocus('name');
  }, [isDisabled]);

  return (
    <Stack sx={{ gap: 1.25 }}>
      <Controller
        name="name"
        control={control}
        rules={{ required: true }}
        render={({ field, fieldState: { error } }) => (
          <Input
            {...field}
            label="Goal Title"
            placeholder="Type goal title..."
            errorsNames={
              error && { ...error, message: 'This field is required' }
            }
            disabled={isDisabled}
            labelInTop={true}
            inputWrapperCustomClass="max-w-[600px]"
            maxLength={100}
          />
        )}
      />

      <Controller
        name="description"
        control={control}
        rules={{ required: true }}
        render={({ field, fieldState: { error } }) => (
          <TextArea
            {...field}
            label="Goal Description"
            placeholder="Type goal description..."
            disabled={isDisabled}
            rows={5}
            error={!!error}
            errorMessage={error && 'This field is required'}
            sx={{ maxWidth: 600 }}
          />
        )}
      />
    </Stack>
  );
};

export default OtherGoalForm;
